export interface FilterState {
  genre: string;
  decade: string;
  region: string;
  rating: string;
}

interface FilterPanelProps {
  state: FilterState;
  onChange: (patch: Partial<FilterState>) => void;
  onReset: () => void;
  genres: string[];
  decades: string[];
  regions: string[];
}

const ratingOptions = ["全部", "8.0分以上", "7.0-7.9分", "6.0-6.9分"];

function Group({
  label,
  value,
  options,
  onSelect,
}: {
  label: string;
  value: string;
  options: string[];
  onSelect: (v: string) => void;
}) {
  return (
    <div className="border-b border-background-200/80 pb-5 last:border-b-0">
      <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-900">
        <span className="h-3.5 w-0.5 rounded-full bg-accent-500"></span>
        {label}
      </h3>
      <div className="flex flex-wrap gap-2">
        {["全部", ...options].map((opt) => {
          const isActive = value === opt || (opt === "全部" && !value);
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onSelect(opt === "全部" ? "" : opt)}
              className={[
                "cursor-pointer whitespace-nowrap rounded-md border px-2.5 py-1 text-xs font-medium transition-colors",
                isActive
                  ? "border-primary-600 bg-primary-600 text-background-50"
                  : "border-background-300/80 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700",
              ].join(" ")}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({ state, onChange, onReset, genres, decades, regions }: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-700"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-medium text-secondary-600 transition-colors hover:text-accent-600"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>
      <Group label="类型" value={state.genre} options={genres} onSelect={(v) => onChange({ genre: v })} />
      <Group label="年代" value={state.decade} options={decades} onSelect={(v) => onChange({ decade: v })} />
      <Group label="地区" value={state.region} options={regions} onSelect={(v) => onChange({ region: v })} />
      <Group label="评分区间" value={state.rating} options={ratingOptions.slice(1)} onSelect={(v) => onChange({ rating: v })} />
    </div>
  );
}